module.exports = __webpack_public_path__ + "img/CECA_Fibroblasts.94f8f7ad.png";